module.exports = __webpack_public_path__ + "img/yule_image.f8af5193.png";